import { CHANGE_STATE } from "../Actions/ActionTypes"
  
  const MainReducer = (state =true, action) => {
    switch (action.type) {
      case CHANGE_STATE:
        return action.payload 
      default:
        return state
    }
  }
  export default MainReducer